module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-01-m-jp.3d5f9a685bdb8458ea711d32df23a174.png";